"use client";
import { Ref, forwardRef } from "react";
import { components } from "react-select";
import { HiChevronDown } from "react-icons/hi";
import CreatableSelect from "react-select/creatable";
import classNames from "classnames";

function ReactSelect(
  {
    options,
    onChange,
    isDisabled,
    label,
    setSelected,
    selected,
    isMulti = false,
    variant = "normal",
    className,
  }: {
    options: any;
    value?: any;
    variant?: "rounded" | "normal";
    isMulti?: boolean;
    isDisabled?: boolean;
    onChange?: () => void;
    label: string;
    selected: any;
    setSelected: (e: any) => void;
    className?: string;
  },
  ref: Ref<HTMLDivElement>
) {
  return (
    <div
      className={`${classNames(
        `py-2 bg-main/10 md:bg-none relative z-10 p-2 md:p-0 mr-6 md:mr-0 outline-none ${className} `
      )} ${variant === "rounded" && ""} `}
    >
      <CreatableSelect
        placeholder={label}
        components={{
          Option: CustomSelectOption,
          Control: CustomControl,
          DropdownIndicator: DefaultDropdownIndicator,
        }}
        isMulti={isMulti}
        value={selected}
        isDisabled={isDisabled}
        isClearable={true}
        onChange={(e) => {
          setSelected(e);
          onChange && onChange();
        }}
        className=" bg-white text-black text-sm rounded-md "
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: state.isFocused ? "0" : "0",
            background: "none",
            boxShadow: "0 !important",
            color: "#817c7c",
          }),
        }}
        options={options}
      />
    </div>
  );
}

const CustomSelectOption = ({
  innerProps,
  label,
  value,
  data,
  isSelected,
}: any) => {
  return (
    <div className={`${"  "}  ${isSelected && ""}`} {...innerProps}>
      <div
        className={" my-2 "}
        style={{ zIndex: "100", position: "relative", display: "flex" }}
      >
        {data?.image && <img src={data.image} height={30} width={30} alt="" />}
        <span className="ml-2 bg-red-00  w-fit rtl:mr-2">{`${label} - ${value}`}</span>
      </div>
      {/* {isSelected && <HiCheck className="text-emerald-500 text-xl" />} */}
    </div>
  );
};

const CustomControl = ({ children, ...props }: any) => {
  const selected = props.getValue()[0];
  const { Control } = components;

  return (
    <Control {...props}>
      {selected && selected?.image && (
        <img src={selected.image} height={30} width={30} alt="" />
      )}
      {children}
    </Control>
  );
};

const DefaultDropdownIndicator = () => {
  return (
    <div className="select-dropdown-indicator">
      <HiChevronDown />
    </div>
  );
};

const AppSelect = forwardRef(ReactSelect);

export default AppSelect;
